/**
 * Quick Add to Cart — behavior
 * Load as a deferred script (theme.js bundle or its own asset with `defer`).
 *
 * Flow:
 *  1. Click "+" → reveal size pills, close any other open quick-add on the page
 *  2. Click a size → POST /cart/add.js → on success, open cart drawer + refresh drawer content
 *  3. Click outside or the close (×) button → collapse back to "+"
 */

(function () {
  function closeAllQuickAdds(except) {
    document.querySelectorAll('[data-qa-fab]').forEach(function (root) {
      if (root === except) return;
      var sizes = root.querySelector('[data-qa-fab-sizes]');
      var trigger = root.querySelector('[data-qa-fab-trigger]');
      if (sizes) sizes.hidden = true;
      if (trigger) trigger.hidden = false;
    });
  }

  function setFeedback(root, message) {
    var el = root.querySelector('[data-qa-fab-feedback]');
    if (el) el.textContent = message || '';
  }

  async function addVariantToCart(variantId) {
    // Dawn-based themes use fixed section IDs matching the section filename,
    // not a DOM attribute. 'cart-drawer' and 'cart-icon-bubble' are the
    // standard Dawn section IDs for this. Shopify silently ignores any
    // section ID that doesn't exist, so it's safe to always request both.
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.description || data.message || 'Could not add to cart');
    }
    return data;
  }

  function swapSectionHtml(targetSelector, html, innerSelector) {
    var target = document.querySelector(targetSelector);
    if (!target || !html) return false;

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var freshInner = innerSelector ? doc.querySelector(innerSelector) : doc.body.firstElementChild;
    if (!freshInner) return false;

    target.innerHTML = freshInner.innerHTML;

    // The fresh markup also carries the correct is-empty state on its root —
    // mirror that onto the live element's classList too, since we only
    // replaced innerHTML and kept the original outer tag.
    if (freshInner.classList.contains('is-empty')) {
      target.classList.add('is-empty');
    } else {
      target.classList.remove('is-empty');
    }

    return true;
  }

  async function refreshAndOpenCartDrawer(addResponseData) {
    var drawer = document.querySelector('cart-drawer');
    var sections = addResponseData && addResponseData.sections;

    if (drawer && sections && sections['cart-drawer']) {
      swapSectionHtml('cart-drawer', sections['cart-drawer'], 'cart-drawer');

      // Also sync is-empty on the nested cart-drawer-items element, since
      // it carries its own independent is-empty class in this theme.
      var freshItems = new DOMParser()
        .parseFromString(sections['cart-drawer'], 'text/html')
        .querySelector('cart-drawer-items');
      var liveItems = document.querySelector('cart-drawer-items');
      if (freshItems && liveItems) {
        if (freshItems.classList.contains('is-empty')) {
          liveItems.classList.add('is-empty');
        } else {
          liveItems.classList.remove('is-empty');
        }
      }
    }

    // Update the little cart count bubble in the header too, if present
    if (sections && sections['cart-icon-bubble']) {
      var bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) {
        swapSectionHtml('#cart-icon-bubble', sections['cart-icon-bubble'], null);
      }
    }

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    // Many themes listen for these events to refresh + open the drawer
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

    // Fallback: some themes toggle a class/attribute on a drawer element
    var fallbackDrawer = document.querySelector('[data-cart-drawer], #CartDrawer, .cart-drawer');
    if (fallbackDrawer) {
      fallbackDrawer.classList.add('active', 'is-open', 'animate');
      fallbackDrawer.removeAttribute('hidden');
      return true;
    }

    return false;
  }

  document.addEventListener('click', async function (e) {
    const root = e.target.closest('[data-qa-fab]');

    // Click outside any quick-add → close all open ones
    if (!root) {
      closeAllQuickAdds(null);
      return;
    }

    const trigger = e.target.closest('[data-qa-fab-trigger]');
    const closeBtn = e.target.closest('[data-qa-fab-close]');
    const sizeBtn = e.target.closest('[data-qa-fab-size]');
    const sizesPanel = root.querySelector('[data-qa-fab-sizes]');

    if (trigger) {
      closeAllQuickAdds(root);
      trigger.hidden = true;
      sizesPanel.hidden = false;
      setFeedback(root, '');
      return;
    }

    if (closeBtn) {
      sizesPanel.hidden = true;
      root.querySelector('[data-qa-fab-trigger]').hidden = false;
      return;
    }

    if (sizeBtn) {
      if (sizeBtn.disabled || sizeBtn.dataset.available === 'false') {
        setFeedback(root, 'This size is sold out.');
        return;
      }

      const variantId = sizeBtn.dataset.variantId;
      sizeBtn.classList.add('is-loading');
      setFeedback(root, '');

      try {
        const addData = await addVariantToCart(variantId);

        const opened = await refreshAndOpenCartDrawer(addData);
        if (!opened) {
          setFeedback(root, 'Added to cart.');
        }

        // Reset back to "+" state after a short delay
        setTimeout(function () {
          sizesPanel.hidden = true;
          root.querySelector('[data-qa-fab-trigger]').hidden = false;
          sizeBtn.classList.remove('is-loading');
        }, 400);
      } catch (err) {
        sizeBtn.classList.remove('is-loading');
        setFeedback(root, err.message || 'Something went wrong. Try again.');
      }
      return;
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllQuickAdds(null);
  });
})();
